let TokenKey = 'User-Token'
if (process.env.MODE === 'testing') {
  TokenKey = 'Test-User-Token'
}

export function getToken () {
  return sessionStorage.getItem(TokenKey)
}

export function setToken (token) {
  return sessionStorage.setItem(TokenKey, token)
}

export function removeToken () {
  sessionStorage.setItem(TokenKey, '')
  return sessionStorage.removeItem(TokenKey)
}
